import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '@core/auth/auth-guard.service';
import { ClientGuardService } from '@core/auth/client-guard-service';
import { UserGuardService } from '@core/auth/user-guard-service';
import { AccountGuardService } from '@core/auth/account-guard-service';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';
import { ClientAccountChoiceComponent } from '@shared/components/client-account-choice/client-account-choice.component';
import { UserChoiceComponent } from '@shared/components/user-choice/user-choice.component';

import { HomeDashboardComponent } from './orders/components/home-dashboard/home-dashboard.component';
import { ProductNotSupportedComponent } from './shared/components/product-not-supported/product-not-supported.component';
import { UnauthorizedComponent } from './shared/errors/unauthorized/unauthorized.component';
import { LoginComponent } from '@shared/components/auth/login/login.component';
import { LoadingComponent } from '@shared/components/auth/loading/loading.component';
import { ProcessCompletedComponent } from '@shared/components/auth/process-completed/process-completed.component';

const routes: Routes = [
  {
    path: '',
    component: LoadingComponent,
  },
  {
    path: 'process-completed',
    component: ProcessCompletedComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: HomeDashboardComponent,
    canActivate: [ AuthGuardService, UserGuardService, ClientGuardService ],
    data: { title: 'Dashboard' },
  },
  {
    path: 'user-choice',
    component: UserChoiceComponent,
    canActivate: [ AuthGuardService ],
    data: { title: 'PAGE.USER_CHOICE.TITLE' },
  },
  {
    path: 'client-account-choice',
    component: ClientAccountChoiceComponent,
    canActivate: [ AuthGuardService, UserGuardService ],
    data: { title: 'PAGE.CLIENT_ACCOUNT_CHOICE.TITLE' },
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./orders/orders.module').then((m) => m.OrdersModule).catch(err => {
        console.log('mallow', err);
      }),
    canActivate: [ AuthGuardService, UserGuardService, ClientGuardService, AccountGuardService ]
  },
  {
    path: 'csv',
    loadChildren: () =>
     import('./csv/csv.module').then((m) => m.CsvModule).catch(err => {
      console.log('mallow', err);
     }),
     canActivate: [AuthGuardService, UserGuardService, ClientGuardService, AccountGuardService]
  },
  {
    path: 'massive',
    loadChildren: () =>
     import('./massive-upload-wizard/massive-upload-wizard.module').then((m) => m.MassiveUploadWizardModule).catch(err => {
      console.log('mallow', err);
     }),
     canActivate: [AuthGuardService, UserGuardService, ClientGuardService, AccountGuardService]
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./search/search.module').then((m) => m.SearchModule).catch(err => {
        console.log('mallow', err);
      }),
    canActivate: [ AuthGuardService, UserGuardService, ClientGuardService ]
  },
  {
    path: 'timestamps',
    loadChildren: () =>
     import('./timestamps/timestamps.module').then((m) => m.TimestampsModule).catch(err => {
       console.log('mallow', err);
     }),
     canActivate: [ AuthGuardService, UserGuardService, ClientGuardService ]
  },
  {
    path: 'documentation',
    loadChildren: () =>
      import('./documentation/documentation.module').then(m => m.DocumentationModule),
    canActivate: [ AuthGuardService, UserGuardService ],
    data: { title: 'PAGE.TEMPLATES.TITLE' },
  },
  {
    path: 'not-supported', component: ProductNotSupportedComponent
  },
  { path: 'error-unauthorized', component: UnauthorizedComponent},
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { useHash: true },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
